module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_czuwanie_2.4ce10c1b.svg";